module.exports = __webpack_public_path__ + "static/media/quota-usage.309caaad.png";